import CustomModal from "@UI/CustomModal"
import CustomPopoverConfirm from "@UI/CustomPopoverConfirm"
import { CustomSelect } from "@UI/CustomSelect"
import CustomUploadFile from "@UI/CustomUploadFile/CustomUploadFile"
import { Button, Form } from "antd"
import { ReactComponent as InfoIcon } from '@pages/collectionAdministration/pages/NewEditTemplateCollection/components/NewEditTemplateCollectionBody/components/NewEditTemplateCollectionBodyOptions/assets/infoTooltipIcon.svg'
import PropTypes from "prop-types"
import { useExtraordinaryPaymentModal } from "./hooks/useExtraordinaryPaymentModal"


const ExtraordinaryPaymentModal = ({
  isOpen,
  onClose,
  record
}) => {
  const {
    form,
    loadingExtraordinaryPaymentModal,
    paymentTypes,
    fileList,
    setFileList,
    handleSaveExtraordinaryPayment,
  } = useExtraordinaryPaymentModal({ handleOpenCloseModal: onClose, record })

  return (
    <CustomModal
      destroyOnClose={true}
      className="custom-modal"
      isOpenModal={isOpen}
      onCancel={() => {
        onClose({ isOpenModal: false, name: 'extraordinary_payment' })
        form.resetFields()
      }}
      width={450}
    >
      <div className="recurrency-modal-title">
        <span>Pago extraordinario</span>
        <CustomPopoverConfirm
          placement={'bottom'}
          overlayClassName={'info-tooltip-popover'}
          content={<div className="info-tooltip-popover-content">
            <p>Define el monto de mora que se aplicará si el pago se realiza después de la fecha límite:</p>
            <p>Porcentaje: Se calcula un porcentaje sobre el saldo adeudado.</p>
            <p>Cantidad fija: Se aplica un monto específico sin importar el saldo pendiente.</p>
          </div>}
          maxWidth={325}
        >
          <Button
            icon={<InfoIcon />}
            className="btn-standard-transparent"
            shape="circle"
            style={{ marginLeft: '8px', width: '32px' }}
          />
        </CustomPopoverConfirm>
      </div>
      <Form
        className="recurrency-modal-form"
        form={form}
        layout="vertical"
        onFinish={(values) => handleSaveExtraordinaryPayment({ values })}
      >
        <Form.Item
          label={'Tipo de cobro'}
          name="charge_instance_debtor_payment_type_id"
          rules={[{ required: true, message: 'El campo es necesario' }]}
        >
          <CustomSelect
            options={paymentTypes}
            placeholder={'Tipo de cobro'}
          />
        </Form.Item>
        <Form.Item
          name="file"
          rules={[{
            required: true, message: 'El campo es necesario', validator: () => {
              if (!fileList.length)
                return Promise.reject(new Error('Debe seleccionar un archivo'))
              form.setFieldsValue({
                file: fileList?.[0]
              });
              return Promise.resolve();
            }
          }]}
        >
          <CustomUploadFile
            height={250}
            minHeight={250}
            fileList={fileList}
            setFileList={setFileList}
          />
        </Form.Item>
        <div className="recurrency-modal-form-footer">
          <Button
            loading={loadingExtraordinaryPaymentModal}
            htmlType="submit"
            className="btn-standard-green"
            shape="round"
            style={{ width: '133px' }}
          >
            GUARDAR
          </Button>
        </div>
      </Form>
    </CustomModal>
  )
}

ExtraordinaryPaymentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired
}


export default ExtraordinaryPaymentModal
